import coreClient from "../../services/coreApi";

export const useResetPassword = () => {
  const resetPassword = async (payload) => {
    try {
      const response = await coreClient.post('/auth/reset-password', payload );
      console.log(response, 'response')
      return response;
    } catch (error) {
      throw error;
    }
  };

  return { resetPassword };
}

